export default "__VITE_ASSET__DL$flnF5__"